import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import WorkflowStep from "./WorkflowStep";
import ActionSelector from "./ActionSelector";

export type WorkflowStepType = {
  id: string;
  type: "trigger" | "action" | "condition";
  title: string;
  description: string;
  icon?: React.ComponentType;
  config?: Record<string, any>;
};

interface WorkflowBuilderProps {
  initialSteps?: Omit<WorkflowStepType, "id">[];
}

const WorkflowBuilder = ({ initialSteps = [] }: WorkflowBuilderProps) => {
  const [steps, setSteps] = useState<WorkflowStepType[]>(() =>
    initialSteps.map((step) => ({
      ...step,
      id: crypto.randomUUID(),
    }))
  );
  const [showActionSelector, setShowActionSelector] = useState(false);

  const handleAddStep = (newStep: WorkflowStepType) => {
    setSteps([...steps, newStep]);
    setShowActionSelector(false);
  };

  return (
    <div className="min-h-[500px] bg-white rounded-lg p-6 border border-gray-200 shadow-sm">
      <div className="space-y-6">
        {/* Workflow Steps */}
        <div className="space-y-4">
          {steps.map((step, index) => (
            <div key={step.id} className="relative">
              <WorkflowStep step={step} />
              {index < steps.length - 1 && (
                <div className="absolute left-6 top-full h-4 w-0.5 bg-gradient-to-b from-primary/30 to-primary/10" />
              )}
            </div>
          ))}
        </div>

        {/* Add Step Button */}
        {!showActionSelector ? (
          <Button
            variant="outline"
            className="w-full mt-4 border-dashed border-2"
            onClick={() => setShowActionSelector(true)}
          >
            <Plus className="w-4 h-4 mr-2" />
            Add Step
          </Button>
        ) : (
          <ActionSelector
            onSelect={handleAddStep}
            onCancel={() => setShowActionSelector(false)}
          />
        )}
      </div>
    </div>
  );
};

export default WorkflowBuilder;